<template>
  <div>
    <div class="order-list">
      <van-list v-model="loading" :finished="finished" finished-text="已加载完毕" @load="load">
        <div v-for="order in result.rows" :key="order.receiptId" class="order-card" @click="selectOrder(order)">
          <div class="order-cell">
            <div class="order-cell-left">{{order.createTime | datetime('YYYY年M月D日 HH:mm')}}</div>
            <div class="order-cell-right">{{order.amount}}元</div>
          </div>
          <div class="order-cell">
            <div class="order-cell-left order-parking-location">抬头: {{order.title}}</div>
            <div class="order-cell-right order-parking-location"></div>
          </div>
          <div class="order-cell">
            <div class="order-cell-left"><small v-if="order.tips">提示: {{order.tips}}</small></div>
            <div class="order-cell-right" v-if="order.status=='APPLIED'"><van-tag type="success">已申请</van-tag></div>
            <div class="order-cell-right" v-else-if="order.status == 'CONFIRMED'"><van-tag type="primary">处理中</van-tag></div>
            <div class="order-cell-right" v-else-if="order.status == 'INVOICED'"><van-tag>已开具</van-tag></div>
          </div>
        </div>
      </van-list>
    </div>
    <van-goods-action safe-area-inset-bottom>
      <van-goods-action-button color="#0089f5" @click="apply">+ 发票申请</van-goods-action-button>
    </van-goods-action>
  </div>
</template>
<script>
import { Tabs, Tab, List, GoodsAction, GoodsActionButton, ActionSheet, Button, Loading, Tag} from 'vant';
import { router } from '../router';

export default {
  components: {
    [Tabs.name] : Tabs,
    [Tab.name] : Tab,
    [List.name] : List,
    [GoodsAction.name] : GoodsAction,
    [GoodsActionButton.name] : GoodsActionButton,
    [ActionSheet.name] : ActionSheet,
    [Button.name] : Button,
    [Loading.name] : Loading,
    [Tag.name] : Tag
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      finished : false,
      loading : false,
      result: {
        rows: [],
        total: 0
      }
    };
  },
  methods: {
    selectOrder(order) {
      const { receiptId } = order;
      router.push('/invoice?receiptId='+receiptId)
    },
    async load(){
      this.loading = true;
      const data = await this.$http.get('/receipt/history', {page: this.page, pageSize: this.pageSize});
      if (this.page == 1) {
        this.result = data;
      } else {
        this.result.rows = this.result.rows.concat(data.rows);
      }
      if (this.page < Math.ceil(this.result.total / this.pageSize)) {
          this.page ++ ;    
      } else {
        this.finished = true
      }
      
      this.loading = false;
    },
    apply() {
      router.push('invoice_apply');
    }
  }
};
</script>

<style lang="less" scoped>
  .action-popup{
    min-height: 350px;
    padding-top: 4px;
    display: flex;
    flex-direction: column;
  }
  .order-card {
    background-color: white;
    margin: 10px;
    padding: 15px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  }
  .order-cell{
    display: flex;
    justify-content: space-between;
    
  }
  .order-parking-location {
    color: gray;
    padding: 10px 0;
  }
  .parking-time {
    font-size: 12px;
    color: gray;
  }
</style>